// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SelectFilter_wrapper__tqGik","variant":"SelectFilter_variant___Mrj8","title":"SelectFilter_title__UaLsX"};